import React from 'react';
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import moment from 'moment';

import styles from './ReservationUpdatedModal.module.css';


function ReservationUpdatedModal(props) {

  const {
    mode,
    show,
    onHide,
    values,
    handleDelete,
  } = props;

  const setting = useSelector(({ generalSetting }) => generalSetting && generalSetting.setting);
  const rentals = useSelector(({ rentals }) => rentals && rentals.rentals);

  const targetName = mode === 'notification' ? 'Notification' : 'Activity';
  const firstBooking = (values?.bookingData && values.bookingData[0]);
  const secondBooking = (values?.bookingData && values.bookingData[1]);

  const formatToFloat = (number) => {
    return number ? Number(number).toFixed(2) : '0.00';
  };

  const labelAndValueComponent = ({label, value, index, isUpdated}) => (
    <p key={index}>
      <span className={styles.firstColumn}>{label}</span>
      <span>{value}</span>
      {isUpdated && label !== 'Modified:' && (
        <span className={styles.modifiedValue}>Updated!</span>
      )}
    </p>
  );

  const getGuestsNumber = (noOfGuests, noOfAdults, noOfChildren) => {
    if (noOfChildren) {
      return (
        <>
          <span>{noOfGuests}</span>
          <span className={styles.guestsNumber}>{`(${noOfAdults} adults, ${noOfChildren} child)`}</span>
        </>
      );
    };
    return (
      <>
        <span>{noOfGuests}</span>
        <span className={styles.guestsNumber}>{`(${noOfAdults} adults)`}</span>
      </>
    );
  };
  
  const getRentalNameById = (rentalId) => {
    return rentals.find(rental => rental.id === rentalId)?.name || 'N/A';
  };

  const getGuestNameByBookingTitle = (bookingName) => {
    return bookingName.split('|')[0].trim();
  };

  const labelAndValueList = [
    { label: 'Rental:',           value: firstBooking?.rentalId       && getRentalNameById(firstBooking.rentalId) },
    { label: 'Name:',             value: firstBooking?.title          && getGuestNameByBookingTitle(firstBooking.title) },
    { label: 'Arrival date:',     value: firstBooking?.arrive         && moment(firstBooking?.arrive).format('DD MMMM YYYY') },
    { label: 'Departure date:',   value: firstBooking?.depart         && moment(firstBooking?.depart).format('DD MMMM YYYY') },
    { label: 'Total nights:',     value: firstBooking?.nights },
    { label: 'Guests:',           value: firstBooking?.noOfGuests,    component: (firstBooking?.noOfGuests && firstBooking?.noOfAdults && getGuestsNumber(firstBooking.noOfGuests, firstBooking.noOfAdults, firstBooking.noOfChildren)) },
    { label: 'Adults:',           value: firstBooking?.noOfAdults },
    { label: 'Total:',            value: firstBooking?.price          && formatToFloat(firstBooking.price) },
    { label: 'Received:',         value: firstBooking?.createdAt      && moment(firstBooking?.createdAt).format('DD MMM YYYY hh:mm a') },
  ];

  const labelAndValueListUpdated = [
    { label: 'Rental:',           value: secondBooking?.rentalId      && getRentalNameById(secondBooking.rentalId) },
    { label: 'Name:',             value: secondBooking?.title         && getGuestNameByBookingTitle(secondBooking.title) },
    { label: 'Arrival date:',     value: secondBooking?.arrive        && moment(secondBooking?.arrive).format('DD MMMM YYYY') },
    { label: 'Departure date:',   value: secondBooking?.depart        && moment(secondBooking?.depart).format('DD MMMM YYYY') },
    { label: 'Total nights:',     value: secondBooking?.nights },
    { label: 'Guests:',           value: secondBooking?.noOfGuests,   component: (secondBooking?.noOfGuests && secondBooking?.noOfAdults && getGuestsNumber(secondBooking.noOfGuests, secondBooking.noOfAdults, secondBooking.noOfChildren)) },
    { label: 'Adults:',           value: secondBooking?.noOfAdults },
    { label: 'Total:',            value: secondBooking?.price         && formatToFloat(secondBooking.price) },
    { label: 'Modified:',         value: secondBooking?.createdAt     && moment(secondBooking?.createdAt).format('DD MMM YYYY hh:mm a') },
  ];

  const handleAction = () => {
    if (values) {
      const { id } = values;
      handleDelete(id);
    };
    onHide();
  };

  const handleClose = () => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id='contained-modal-title-vcenter'
          className={styles.modalTitle}
        >
          {values?.message}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <p>There were changes made to a reservation.</p>
        <p>Old reservation details:</p>
        <div className={styles.contentContainer}>
          { labelAndValueList.map((item, index)=> labelAndValueComponent({
            index: index,
            label: item.label,
            value: item?.component ? item.component : item.value,
          }))}
        </div>
        <br />
        <p>New reservation details:</p>
        <div className={styles.contentContainer}>
          { labelAndValueListUpdated.map((item, index)=> labelAndValueComponent({
            index: index,
            label: item.label,
            value: item?.component ? item.component : item.value,
            isUpdated: labelAndValueList[index].value !== labelAndValueListUpdated[index].value,
          }))}
        </div>
        <div className={styles.modalButtonContainer}>
          <button
            onClick={handleClose}
            className={styles.grayButton}
          >
            Close
          </button>
          { mode === 'notification' &&
            <button
              onClick={handleAction}
              className={styles.redButton}
            >
              Delete Notification
            </button>
          }
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ReservationUpdatedModal;